import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Antibiogramm, AntibiogrammTierartApi, VerdachtApi } from './antibiogramm';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';

@Injectable({ providedIn: 'root' })
export class AntibiogrammService {
    constructor(
        private readonly http: HttpClient,
        private readonly localStorageService: LocalStorageService,
        private readonly router: Router,
        private readonly pdfService: PdfViewerDesktopService,
        private readonly api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl,
    ) {}

    getAntibiogramm(id: string): Observable<Antibiogramm> {
        return this.http.get<Antibiogramm>(this.apiBaseUrl + 'antibiogramm/read_one.php?antibiogramm_id=' + id);
    }

    recreateAntibiogramm(antibiogramm: Antibiogramm): Observable<Antibiogramm> {
        return this.http.get<Antibiogramm>(
            this.apiBaseUrl + 'antibiogramm/update_pdf.php?antibiogramm_id=' + antibiogramm.antibiogramm_id,
        );
    }

    updateAntibiogramm(antibiogramm: Antibiogramm): Observable<Antibiogramm> {
        return this.http.post<Antibiogramm>(this.apiBaseUrl + 'antibiogramm/update.php', antibiogramm);
    }

    deleteAntibiogramm(antibiogramm: Antibiogramm): Observable<void> {
        return this.http.post<void>(this.apiBaseUrl + 'antibiogramm/delete.php', antibiogramm);
    }

    ladeTierarten(): Observable<AntibiogrammTierartApi> {
        return this.http.get<AntibiogrammTierartApi>(this.apiBaseUrl + 'tierart/read_labor.php');
    }

    ladeVerdachte() {
        return this.http.get<VerdachtApi>(this.apiBaseUrl + 'verdacht/read.php');
    }

    showPdf(antibiogramm: Antibiogramm) {
        let titel: string = antibiogramm.gruppe_nr_intern
            ? antibiogramm.gruppe_nr_intern
            : antibiogramm.kunde_nr_intern?.toString();
        titel +=
            ' ' +
            (antibiogramm.kunde ? antibiogramm.kunde : '') +
            ', ' +
            (antibiogramm.kunde_ort ? antibiogramm.kunde_ort : '') +
            ' (' +
            (antibiogramm.tagebuch_nr ? antibiogramm.tagebuch_nr : '') +
            ')';

        const input = new PdfViewerDialogInput(
            'antibiogramm/read_or_mail_pdf.php',
            new HttpParams().append('antibiogramm_id', antibiogramm?.antibiogramm_id?.toString()),
            titel,
            { email: { sende_mail: true, kunde_id: antibiogramm.kunde_id } },
        );
        this.pdfService.openPdfViewer(input).subscribe({
            next: () => {
                this.api.reload('showPdf');
            },
        });
    }
}
